<template lang="pug">

  #groupCreationFormContainer

    v-card-text.card

      v-container

        v-row.px-0.px-md-8

          //-
            -
            - COLUNA DA IMAGEM
            -
            -

          v-col(cols="12" sm="12" md="5").column.xs

            .editGroup__groupImage
              input(id="groupImageInput" ref="groupImage" type="file" :disabled="loading" v-show="false" accept="image/png,image/jpg" @change="onGroupImageSelect")
              .editGroup__groupImageContainer
                .editGroup__groupImagePreview(:style="{'background-image': (`url('${groupImage.preview}')`)}")
                sos-button(:disabled="loading" size="medium" buttonIconSize="16" buttonIcon="mdi-pencil" color="blue" buttonLabel="" @buttonClick="groupImageLabelClick" rounded).editGroup__groupImageButton
              .mt-2(v-if="groupImage.loaded")
                sos-button(:disabled="loading" size="medium" buttonIconSize="16" buttonIcon="mdi-trash-can" color="danger" buttonLabel="Limpar" @buttonClick="groupImageClear")

          //-
            -
            - COLUNA DOS CAMPOS
            -
            -

          v-col(cols="12" sm="12" md="7").column.xs

            //-
              -
              - INFORMAÇÕES DO GRUPO
              -
              -

            .settingsSubtitle.settingsSubtitle--clearTop
              | INFORMAÇÕES DO GRUPO

            .createTurnField
              label.csLabel
                span(v-html="'Nome *'")
              .csFields
                input(v-model="groupName" :disabled="loading" class="sosInput" maxlength="64")

            .createTurnField
              label.csLabel
                span(v-html="'Descrição *'")
              .csFields
                input(v-model="groupDescription" :disabled="loading" class="sosInput" maxlength="128")

            .createTurnField
              label.csLabel
                span(v-html="'CNPJ <span class=\"vLabelDescription\">(Opcional)</span>'")
              .csFields
                input(v-model="groupCnpj" :disabled="loading" v-mask="'##.###.###/####-##'" class="sosInput" maxlength="18" placeholder="99.999.999/9999-99")

            //-
              -
              - CONFIGURAÇÕES DO APLICATIVO
              -
              -

            .settingsDivider.settingsDivider--variant

            .settingsSubtitle.settingsSubtitle--clearTop
              | CONFIGURAÇÕES DO APLICATIVO

            //- .settingsSubtitle.settingsSubtitle--clearTop
            .settingsSubtitle
              span.inlineMiddle.mr-1 Ações de plantão

              v-tooltip(top color="rgba(0, 0, 139, 0.95)")
                template(v-slot:activator="{ on, attrs }")
                  i(v-bind="attrs" v-on="on" aria-hidden="true" class="mdi mdi-help-circle" style="cursor: pointer; font-size: 20px; line-height: 1; vertical-align: middle")
                span
                  span(style="line-height: 1")
                    b(style="color: #FFFF00") &nbsp;Iniciar plantão apenas no dia do plantão
                    br
                    b.inlineMiddle &nbsp;Plantonista pode iniciar plantão apenas no dia do plantão

            .settingItem
              .settingItemName Usuários podem criar plantões
              sos-switch(:value="allowCreateDuty" @click="handleCreateDutySetting" :disabled="loading")
            .settingItem
              .settingItemName Plantonista pode "largar" o plantão
              sos-switch(:value="allowPassDuty" @click="handlePassDutySetting" :disabled="loading")
            .settingItem
              .settingItemName Desativar "Iniciar plantão"
              sos-switch(:value="disableShiftStart" @click="handleDisableShiftStartSetting" :disabled="loading")
            .settingItem
              .settingItemName Desativar "Encerrar plantão"
              sos-switch(:value="disableShiftEnd" @click="handleDisableShiftEndSetting" :disabled="loading")
            .settingItem
              .settingItemName Iniciar plantão apenas no dia do plantão
              sos-switch(:value="startShiftOnDayOnly" @click="handleStartShiftOnDayOnlySetting" :disabled="loading || disableShiftStart")
            .settingItem.settingItem--clean
              .settingItemName Plantão com intervalo
              sos-switch(:value="allowPauseDuringShift" @click="handleAllowPauseDuringShiftSetting" :disabled="loading")

            //- .settingsDivider

            //- .settingsSubtitle.settingsSubtitle--clearTop
            .settingsSubtitle
              span.inlineMiddle.mr-1 Notificações

              v-tooltip(top color="rgba(0, 0, 139, 0.95)")
                template(v-slot:activator="{ on, attrs }")
                  i(v-bind="attrs" v-on="on" aria-hidden="true" class="mdi mdi-help-circle" style="cursor: pointer; font-size: 20px; line-height: 1; vertical-align: middle")
                span
                  span(style="line-height: 1")
                    b(style="color: #FFFF00") &nbsp;Lembrar início do plantão
                    br
                    b.inlineMiddle &nbsp;O plantonista receberá uma notificação no seu celular

            .settingItem.settingItem--clean
              .settingItemName Lembrar início do plantão
              sos-switch(:value="remindShiftStart" @click="handleRemindShiftStart" :disabled="loading")

            //- .settingsDivider

            //- .settingsSubtitle.settingsSubtitle--clearTop
            .settingsSubtitle
              span.inlineMiddle.mr-1 Restrições de plantão

              v-tooltip(top color="rgba(0, 0, 139, 0.95)")
                template(v-slot:activator="{ on, attrs }")
                  i(v-bind="attrs" v-on="on" aria-hidden="true" class="mdi mdi-help-circle" style="cursor: pointer; font-size: 20px; line-height: 1; vertical-align: middle")
                span
                  span(style="line-height: 1")
                    b(style="color: #FFFF00") &nbsp;Ocultar valor do plantão
                    br
                    b.inlineMiddle &nbsp;Gestores, plantonista e receptor ainda poderão ver o valor

            .settingItem
              .settingItemName Ocultar valor do plantão
              sos-switch(:value="hideDutyValue" @click="handleDutyValueSetting" :disabled="loading")

            .settingItem.settingItem--clean
              .settingItemName Mostrar somente "plantões" livres
              sos-switch(:value="hideGroupShiftsTab" @click="handleHideGroupShiftsTabSetting" :disabled="loading")

            //- .settingsDivider

            //- .settingsSubtitle.settingsSubtitle--clearTop
            .settingsSubtitle
              span.inlineMiddle.mr-1 Plantão do tipo disponível

              v-tooltip(top color="rgba(0, 0, 139, 0.95)")
                template(v-slot:activator="{ on, attrs }")
                  i(v-bind="attrs" v-on="on" aria-hidden="true" class="mdi mdi-help-circle" style="cursor: pointer; font-size: 20px; line-height: 1; vertical-align: middle")
                span
                  b.inlineMiddle &nbsp;Essas configurações não afetam os gestores do grupo

            .settingItem.settingItem--clean
              .settingItemName Usuários se candidatam para pegar
              sos-switch(:value="allowDutyCandidates" @click="handleAllowDutyCandidatesSetting" :disabled="loading")

            //- .settingsDivider

            //- .settingsSubtitle.settingsSubtitle--clearTop
            .settingsSubtitle
              span.inlineMiddle.mr-1 Passagem de plantão

              v-tooltip(top color="rgba(0, 0, 139, 0.95)")
                template(v-slot:activator="{ on, attrs }")
                  i(v-bind="attrs" v-on="on" aria-hidden="true" class="mdi mdi-help-circle" style="cursor: pointer; font-size: 20px; line-height: 1; vertical-align: middle")
                span
                  span(style="line-height: 1")
                    b(style="color: #FFFF00") &nbsp;Apenas gestores autorizam o recebimento
                    br
                    b.inlineMiddle &nbsp;Ativado: Apenas gestores podem CONFIRMAR ou CANCELAR o recebimento de um plantão
                    br
                    b.inlineMiddle &nbsp;Desativado: Plantonistas (que estão recebendo um plantão) podem ACEITAR ou RECUSAR o recebimento

            .settingItem
              .settingItemName Desativar "Passar plantão"
              sos-switch(:value="disablePassToGroupAndUser" @click="handleDisablePassToGroupAndUserSetting" :disabled="loading")
            .settingItem
              .settingItemName(:class="{ 'sosSwitch--disabled': disablePassToGroupAndUser }") Desativar "Passar para o grupo"
              sos-switch(:value="disablePassToGroup" @click="handleDisablePassToGroupSetting" :disabled="loading || disablePassToGroupAndUser")
            .settingItem
              .settingItemName Confirmar recebimento do plantão
              sos-switch(:value="approvePassDuty" @click="handleAllowApprovePassDutySetting" :disabled="loading")
            .settingItem.settingItem--clean
              .settingItemName Apenas gestores autorizam o recebimento
              sos-switch(:value="whoCanAcceptOrRefuse" @click="handleWhoCanAcceptOrRefuse" :disabled="loading || approvePassDuty === false")

            //-
              -
              - CONFIGURAÇÕES DO APLICATIVO E GESTOR
              -
              -

            .settingsDivider.settingsDivider--variant

            .settingsSubtitle.settingsSubtitle--clearTop
              | CONFIGURAÇÕES DO PAINEL WEB

            .settingsSubtitle
              | Editar escala

            .settingItem.settingItem--clean
              .settingItemName Avisar conflitos em plantões sequenciais
              sos-switch(:value="sequentialShiftConflicts" @click="handleCheckSequentialShiftConflictsSetting" :disabled="loading")

            .createTurnField.createTurnField--no__margin__bottom(v-if="sequentialShiftConflicts === true")
              label.csLabel
                span(v-html="'Intervalo em minutos'")
              .csFields
                input(v-model="sequentialShiftConflictsInterval" :disabled="loading" class="sosInput" maxlength="3" placeholder="Informe de 15 a 180 minutos" @input="onSequentialShiftConflictsIntervalChange(sequentialShiftConflictsInterval)")

            //-
              -
              - LOCAIS DE PLANTÃO
              -
              -

            .settingsDivider.settingsDivider--variant

            .settingsSubtitle
              | LOCAIS DE PLANTÃO

            .settingItem.settingItem--clean
              .settingItemName Pré-definir locais
              sos-switch(:value="presetLocations" @click="handlePresetLocations" :disabled="loading")

            template(v-if="presetLocations === true")

              //- .settingsDivider.settingsDivider

              //- .settingsSubtitle.settingsSubtitle--clearTop
              .settingsSubtitle
                | Adicionar local

              .createTurnField.createTurnField--no__margin
                .csFields.csFields--withSmallButton
                  input(v-model="newGroupLocation" :disabled="loading" class="sosInput" maxlength="64" placeholder="Informe um local")
                  sos-button(:disabled="loading" buttonIcon="mdi-plus" color="success" buttonIconSize="16" @buttonClick="addLocation")

              template(v-if="groupLocations.length > 0")

                //- .settingsDivider.settingsDivider--variant

                //- .settingsSubtitle.settingsSubtitle--clearTop
                .settingsSubtitle
                  | Locais

                .locations

                  table(border="0" cellspacing="0" cellpadding="0").locationsTable
                    thead
                      tr
                        th Local
                        th(width="120") Área
                        th(width="80").last Ações
                    tbody
                      tr(v-for="(groupLocation, groupLocationIndex) in groupLocations" :key="`local_${groupLocationIndex}`")
                        td(data-label="Local")
                          span.groupPlaceName {{ groupLocation.groupPlaceName }}
                        td(data-label="Área")
                          .locationStatus Desativada
                        td(data-label="Ações")
                          sos-button(:disabled="loading" buttonIcon="mdi-trash-can" buttonIconSize="16" @buttonClick="() => deleteLocation(groupLocationIndex)")

            //-
              -
              - AVANÇAR
              -
              -

            .buttonAvancarContainer

              sos-button(@buttonClick="createGroup" size="medium" buttonLabel="AVANÇAR" color="success" buttonIcon="mdi-arrow-right" iconPosition="right" buttonIconSize="16" :loading="loading")

    //-
      -
      - Modal AVISO
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

</template>

<script>
  // import ImageSelectPlaceholder from '@/assets/images/image_select_placeholder.png'
  import groupplaceholder from '@/assets/images/groupplaceholder.png'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'
  import cnpjMixin from '@/mixins/cnpj.mixin'

  // Components
  import SosSwitch from '@/components/SosSwitch'
  import SosButton from '@/components/SosButton'
  import ConfirmDialog from '@/modals/ConfirmDialog'
  import SosRadio from '@/components/SosRadio'

  import { apiCreateGroup } from '@/services/firebase'

  import { handleGroupImageFileLoad, validateLocationName, validateGroupName, validateGroupDescription } from '@/functions/groups'

  // Moment
  // import moment from 'moment'
  // import 'moment/locale/pt-br'
  // moment.locale('pt-BR')

  export default {
    name: 'GroupCreationForm',

    components: {
      'sos-switch': SosSwitch,
      'sos-radio': SosRadio,
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
    },

    mixins: [
      confirmDialogMixin,
      cnpjMixin,
    ],

    data: () => ({
      loading: false,

      groupImage: {
        loaded: false,

        preview: groupplaceholder,
        file: null,

        size: null,
        width: null,
        height: null,
      },
      groupName: '',
      groupDescription: '',
      groupCnpj: '',

      allowPassDuty: false,
      startShiftOnDayOnly: false,
      allowPauseDuringShift: false,
      disableShiftStart: false,
      disableShiftEnd: false,
      remindShiftStart: false,
      allowCreateDuty: false,
      hideDutyValue: false,
      hideGroupShiftsTab: false,

      approvePassDuty: false,
      whoCanAcceptOrRefuse: false,

      allowDutyCandidates: false,
      disablePassToGroupAndUser: false,
      disablePassToGroup: false,
      sequentialShiftConflicts: false,

      presetLocations: true,
      groupLocations: [],
      newGroupLocation: '',

      sequentialShiftConflictsInterval: '60',
    }),

    methods: {
      /**
       *
       * HELPER FUNCTIONS/EVENTS TO HANDLE GROUP IMAGE
       *
       */

      setImage () {
        if (this.loading) return false

        document.getElementById('groupImageInput').click()
      },

      async onGroupImageSelect (event)
      {
        const groupImageFile = this.$refs.groupImage.files[0]
        const loadGroupImageResponse = await handleGroupImageFileLoad(groupImageFile)

        // console.log('onGroupImageSelect[DEBUG]:', { event }, this.$refs.groupImage, loadGroupImageResponse)

        if (loadGroupImageResponse.code === 0)
        {
          if (loadGroupImageResponse.response === false)
          {
            // console.log('::: onGroupImageSelect[DEBUG]: FECHOU O SELETOR SEM SELECIONAR UM ARQUIVO')
          }
          else
          {
            /* CLEAR FILE */
            // this.$refs.groupImage.value = null
            event.target.value = null

            this.groupImage = {
              loaded: false,

              preview: groupplaceholder,
              file: null,

              size: null,
              width: null,
              height: null,
            }

            this.showMessage('Atenção!', loadGroupImageResponse.response)
          }
        }
        else
        {
          this.groupImage.loaded = true
          this.groupImage.file = groupImageFile
          this.groupImage.preview = loadGroupImageResponse.response.preview
          this.groupImage.size = loadGroupImageResponse.response.size
          this.groupImage.width = loadGroupImageResponse.response.width
          this.groupImage.height = loadGroupImageResponse.response.height

          // console.log('::: onGroupImageSelect > image > loaded:', this.groupImage)
        }
      },

      cancelado ()
      {
        // console.log('::: onGroupImageSelect[DEBUG] -> CANCELADO: FECHOU O SELETOR SEM SELECIONAR UM ARQUIVO')

        document.body.onfocus = null
      },

      groupImageLabelClick () {
        if (this.loading) return false

        this.setImage()

        document.body.onfocus = this.cancelado
      },

      groupImageClear () {
        if (this.loading) return false

        if (this.groupImage.loaded) {
          this.$refs.groupImage.value = null

          this.groupImage = {
            loaded: false,

            preview: groupplaceholder,
            file: null,

            size: null,
            width: null,
            height: null,
          }
        }
      },

      /**
       *
       * ?
       *
       */

      async createGroup ()
      {
        if (this.loading) return

        const name = this.groupName ? this.groupName.trim() : ''
        const description = this.groupDescription ? this.groupDescription.trim() : ''
        const cnpj = this.groupCnpj ? this.groupCnpj.trim() : ''

        const checkNome = name ? validateGroupName(name) : false
        const checkDescription = description ? validateGroupDescription(description) : false
        const checkCNPJ = cnpj && cnpj.length > 0 ? this.isValidCNPJ(cnpj) : true // true = OPCIONAL
        const checkLocations = (this.presetLocations === true && this.groupLocations.length > 0) || this.presetLocations === false
        const checkInterval = this.sequentialShiftConflicts === false || (this.sequentialShiftConflicts === true && Number(this.sequentialShiftConflictsInterval) >= 15 && Number(this.sequentialShiftConflictsInterval) <= 180)

        const errors = []

        if (!checkNome) errors.push('Informe um nome entre 3 e 64 caracteres.')
        if (!checkDescription) errors.push('Escreva uma descrição entre 3 e 128 caracteres.')
        if (!checkCNPJ) errors.push('Digite um CNPJ válido ou limpe o campo.')
        if (!checkLocations) errors.push('Informe pelo menos um local ou desmarque a caixa "Pré-definir locais".')
        if (!checkInterval) errors.push('Desative a opção "Avisar conflitos em plantões sequenciais" ou informe um intervalo de 15 a 180 minutos entre um plantão e outro.')

        //
        //
        //

        if (errors.length > 0)
        {
          this.showMessage('Atenção!', errors.length === 1 ? errors[0] : ('- ' + errors.join('<br />- ')))
          return false
        }

        /**
         *
         * DIZ PARA A TELA QUE ESTÁ PROCESSANDO A CRIAÇÃO DO GRUPO
         * PROCESSA
         * DIZ PARA A TELA QUE NÃO ESTÁ MAIS PROCESSANDO A CRIAÇÃO DO GRUPO
         *
         */

        this.loading = true

        const fbDbResponse = await apiCreateGroup({
          // data_atual: api Server Timestamp (), // ACRESCENTADO EM 05/07/2024

          groupImage: this.groupImage,
          groupName: name ? name.trim() : '',
          groupDescription: description ? description.trim() : '',
          groupCnpj: cnpj ? cnpj.trim() : '',

          presetLocations: this.presetLocations,
          groupLocations: this.groupLocations,

          allowCreateDuty: this.allowCreateDuty || null,
          allowPassDuty: this.allowPassDuty || null,
          startShiftOnDayOnly: this.startShiftOnDayOnly || null,
          allowPauseDuringShift: this.allowPauseDuringShift || null,
          disableShiftStart: this.disableShiftStart || null,
          disableShiftEnd: this.disableShiftEnd || null,
          remindShiftStart: this.remindShiftStart || null,
          hideDutyValue: this.hideDutyValue || null,
          hideGroupShiftsTab: this.hideGroupShiftsTab || null,

          approvePassDuty: this.approvePassDuty || null,
          whoCanAcceptOrRefuse: !!this.approvePassDuty === true && !!this.whoCanAcceptOrRefuse === true ? 'apenas_gestores' : null,

          allowDutyCandidates: this.allowDutyCandidates || null,
          disablePassToGroupAndUser: this.disablePassToGroupAndUser || null,
          disablePassToGroup: this.disablePassToGroup || null,
          sequentialShiftConflicts: this.sequentialShiftConflicts || null,
          sequentialShiftConflictsInterval: this.sequentialShiftConflicts === true ? this.sequentialShiftConflictsInterval : null,
        })

        this.loading = false

        // console.log('::: CREATE GROUP -> RESULT:', fbDbResponse)

        if (fbDbResponse.code === 0) {
          this.showMessage('Atenção!', fbDbResponse.response)
          return false
        }

        /* LEVA O USUÁRIO PARA A PÁGINA "CONVIDAR USUÁRIOS" */
        this.$router.push('/admin/grupos/' + fbDbResponse.groupID + '/convidar')
      },

      /**
       *
       * GESTÃO DAS CONFIGURAÇÕES DO GRUPO (NO APP)
       *
       */

      handlePassDutySetting () {
        this.allowPassDuty = !this.allowPassDuty
      },

      handleStartShiftOnDayOnlySetting () {
        this.startShiftOnDayOnly = !this.startShiftOnDayOnly
      },

      handleAllowPauseDuringShiftSetting () {
        this.allowPauseDuringShift = !this.allowPauseDuringShift
      },

      handleDisableShiftStartSetting () {
        this.disableShiftStart = !this.disableShiftStart
      },

      handleDisableShiftEndSetting () {
        this.disableShiftEnd = !this.disableShiftEnd
      },

      handleRemindShiftStart () {
        this.remindShiftStart = !this.remindShiftStart
      },

      handleCreateDutySetting () {
        this.allowCreateDuty = !this.allowCreateDuty
      },

      handleDutyValueSetting () {
        this.hideDutyValue = !this.hideDutyValue
      },

      handleHideGroupShiftsTabSetting () {
        this.hideGroupShiftsTab = !this.hideGroupShiftsTab
      },

      handleAllowApprovePassDutySetting () {
        this.approvePassDuty = !this.approvePassDuty
        if (this.approvePassDuty === false) this.whoCanAcceptOrRefuse = false
      },

      handleWhoCanAcceptOrRefuse (value) {
        this.whoCanAcceptOrRefuse = value
      },

      handleAllowDutyCandidatesSetting () {
        this.allowDutyCandidates = !this.allowDutyCandidates
      },

      handleDisablePassToGroupAndUserSetting () {
        this.disablePassToGroupAndUser = !this.disablePassToGroupAndUser
      },

      handleDisablePassToGroupSetting () {
        this.disablePassToGroup = !this.disablePassToGroup
      },

      handleCheckSequentialShiftConflictsSetting () {
        this.sequentialShiftConflicts = !this.sequentialShiftConflicts
      },

      onSequentialShiftConflictsIntervalChange (inputText) {
        if (!/^\d+$/.test(inputText) || /^0+/.test(inputText)) {
          const newString = inputText.trim().replace(/[^\d]+/g, '').replace(/^0+/, '')
          this.sequentialShiftConflictsInterval = newString.length > 0 ? newString : ''
        }
      },

      /**
       *
       * GESTÃO DOS LOCAIS
       *
       */

      handlePresetLocations () {
        this.presetLocations = !this.presetLocations
      },

      addLocation () {
        const locationName = this.newGroupLocation ? this.newGroupLocation.trim() : ''
        const checkLocationName = locationName ? validateLocationName(locationName) : false

        if (!checkLocationName) {
          // Digite um local contendo entre 3 e 64 caracteres
          this.showMessage('Atenção!', 'Por favor, digite o nome do local. Esse nome deve conter entre 3 e 64 caracteres.')
          return
        }

        const locationExists = this.groupLocations.find(groupLocation => groupLocation.groupPlaceName.toLowerCase() === locationName.toLowerCase())

        if (locationExists) {
          this.showMessage('Atenção!', 'Esse local já existe. Por favor, informe um nome diferente.')
          return
        }

        //

        this.newGroupLocation = ''

        this.groupLocations.push({
          groupPlaceName: locationName,
          isGroupLocationGeofenced: false,
        })
      },

      // DELETE LOCATION (REQUIRE CONFIRMATION)

      deleteLocation (groupPlaceIndex) {
        // deleteLocation (placeID)
        // const groupLocation = this.groupLocations.find(place => place.groupPlaceID === placeID)
        this.groupLocations = this.groupLocations.filter((locale, _index) => _index !== groupPlaceIndex)
      },

      /**
       *
       * DELETE LOCATION (CONFIRMED)
       *
       */

      cdAction (cdResponse) {
        // console.log('cdAction:', cdResponse)
      },
    },
  }
</script>

<style lang="scss" scoped>

  .locations {
    overflow-x: auto;
    margin-top: 15px;
    // margin-top: 22px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
  }

  .locationStatus {
    // margin-top: 5px;

    color: #777777;
    font-size: 14px;
    line-height: 14px;

    /* &.locationStatus--active {
      color: #E54245;
    } */
  }

  //
  //
  //

  #groupCreationFormContainer {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;

    padding-top: 35px;
    // padding-bottom: 70px;
    padding-bottom: 25px;
    margin-top: 50px;
    margin-bottom: 15px;
    border-radius: 4px;
    background-color: #FFFFFF;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);

    color: rgba(0, 0, 0, 0.87);
  }

  .buttonAvancarContainer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 50px;
    /* background-color: green; */
  }

</style>
